// extracted by mini-css-extract-plugin
export default {"qbtn":"question_qbtn__ixsf7","add":"question_add__pHF8v","options":"question_options__jnK4S"};